import { util } from 'pevueglobal'

const state = {
  forminputdata: {
    profGroups: [],
    selectedProfGroup: null,
    loginUrl: ''
  }
}

// getters
const getters = {}

// actions
const actions = {
  getTexten: async ({ dispatch }) => {
    let textIDs = [4901, 4902, 4905, 14642, 15593, 15594]
    dispatch('gettranslations', textIDs, { root: true })
  },
  initProfGroups: async ({ commit, state }, { orgID, profgroupID }) => {
    const data = await util.getDataApi('public/PEapi_SPE610_ExtOrgSelection', {
      SES_bergrpid: profgroupID,
      SES_orgid: orgID
    })
    const profGroups = data.ds.data0
    if (profGroups.some(x => x.value === profgroupID)) {
      // Set selected
      commit('setselectedProfGroup', profgroupID)
    } else if (profgroupID === null && profGroups.length === 1) {
      // Set single profgroup as selected
      commit('setselectedProfGroup', profGroups[0].value)
    }
    commit('setProfGroups', profGroups)
  },
  getloginUrl: async ({ commit, state }, inputdata) => {
    const data = await util.getDataApi('public/PEapi_GetProfgroupLoginUrl', inputdata)
    commit('setloginUrl', data)
  }
}

// mutations
const mutations = {
  setforminputdata(state, forminputdata) {
    state.forminputdata = {
      ...state.forminputdata,
      ...forminputdata
    }
  },
  setFormInput(state, data) {
    state.forminputdata.profGroups = data.ds.data0
  },
  setProfGroups(state, profGroups) {
    state.forminputdata.profGroups = profGroups
  },
  setselectedProfGroup(state, selectedProfGroup) {
    state.forminputdata.selectedProfGroup = selectedProfGroup
  },
  setloginUrl(state, data) {
    state.forminputdata.loginUrl = data.ds.data0[0].loginUrl
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
